module.exports = __webpack_public_path__ + "img/favicon.57d94cbf.png";